<template>
  <div class="flex match-height">
    <div class="w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('Cartable')" class="mt-2">
            <Cartable></Cartable>
          </vs-tab>
          <vs-tab :label="$t('WaitingForDeliveryToCustomer')" class="mt-2">
            <waiting-for-delivery-to-customer></waiting-for-delivery-to-customer>
          </vs-tab>
          <vs-tab :label="$t('Delivered')" class="mt-2">
            <Delivered></Delivered>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import Cartable from "./Cartable/Index.vue";
import WaitingForDeliveryToCustomer from "./WaitingForDeliveryToCustomer/Index.vue";
import Delivered from "./Delivered/Index.vue";
export default {
  name: "shipping-OperationOperators",
  components: {
    Cartable,
    WaitingForDeliveryToCustomer,
    Delivered
  }
};
</script>
